var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","align-content":"space-around","flex-direction":"column","flex-wrap":"wrap"}},[_c('div',{attrs:{"id":"g-reCaptcha"}}),(_vm.captchaError)?_c('p',{staticStyle:{"font-size":"medium","color":"red"}},[_vm._v(_vm._s(_vm.captchaErrorText))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }